import { Locale } from '@rover/constants/src/i18n/lingui.constants';

export const getTrustpilotUrl = (locale: Locale | undefined, reviewSlug = 'rover.com'): URL => {
  if (!locale) return new URL(`https://trustpilot.com/review/${reviewSlug}?languages=all`);
  switch (locale) {
    case Locale.FrCa:
      return new URL(`https://fr.trustpilot.com/review/${reviewSlug}?languages=all`);
    case Locale.EnGb:
      return new URL(`https://uk.trustpilot.com/review/${reviewSlug}?languages=all`);
    default:
      return new URL(
        `https://${locale.split('-')[1]}.trustpilot.com/review/${reviewSlug}?languages=all`
      );
  }
};

export default getTrustpilotUrl;
